module.exports = __webpack_public_path__ + "static/media/robinhood.c1ff0133.png";